import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import AssetCard from "../UI/AssetCard";

export default function AssetSlider({
  assets = [],
  actionLabel,
  actionTo,
  online = false,
}) {
  const responsive = {
    desktop: {
      breakpoint: { max: 4000, min: 1024 },
      items: Math.min(3, assets.length || 1),
    },
    tablet: {
      breakpoint: { max: 1024, min: 768 },
      items: Math.min(2, assets.length || 1),
    },
    mobile: {
      breakpoint: { max: 768, min: 0 },
      items: 1,
    },
  };

  return (
    <Carousel
      responsive={responsive}
      arrows={assets.length > 3}
      infinite={false}
      containerClass="guide-master-carousel"
      itemClass="guide-master-slide px-2"
    >
      {assets.map((asset) => (
        <div key={asset.id} className="guide-master-slide__inner">
          <AssetCard
            asset={asset}
            actionLabel={actionLabel}
            actionTo={actionTo}
            online={online}
          />
        </div>
      ))}
    </Carousel>
  );
}
